export const hexDictionary = {
    '03': '#F6F6F6',
    '04': '#0A0A0A',
    '07': '#c7bc9f',
    '08': '#ff9d5c',
    '10': '#F7F7F7',
    '11': '#262626',
    '13': '#E5E5E5',
    '14': '#45322e',
    '15': '#BFBFBF',
    '16': '#8C8C8C',
    '18': '#293133',
    '21': '#4C4C4C',
    '20': '#FFD700',
    '22': '#323232',
    '23': '#FEF8F4',
    '24': '#D6CAC1',
    '25': '#A19891',
    '28': '#A17B67',
    '27': '#E4D7CD',
    '29': '#363330',
    '36': '#F1D7C3',
    '37': '#A1573E',
    '38': '#A14C2F',
    '40': '#9CB0BC',
    '42': '#708186',
    '45': '#434D50',
    '47': '#A1A095',
    '52': '#B08D57',
    '53': '#6B6B63',
    '54': '#371404',
    '56': '#4A5044',
    '58': '#FAF9F6',
    '61': '#BC663A',
    '62': '#a1b49c',
    '66': '#D3D3D3',
    '67': '#B87333',
    '68': '#BC8A41',
    '72': '#BC8A41',
    '73': '#BC8A41',
    '93': '#F6F6F6',
}

export const composingPendantSubFamilyCodes: Record<string, string[]> = {
    "240": ["0820"],
    "207": ["5664", "5662", "5660"],
    "161": ["0270"],
    "162": ["0920"],
    "184": ["0345", "0361"],
    "203": ["5520", "5525"],
    "214": ["5770", "5772", "5774"],
    "248": ["6160", "6165"],
    "217": ["2350", "2351", "2355"],
    "222": ["5935"],
    "230": ["7450", "7455", "7460", "7470", "7475"],
    "239": ["3235"],
    "253": ["5730"]
}

export const PRODUCT_CATEGORIES = {
    REGULAR: 1,
    SPECIFIC_PLAYER: 2,
    MODULAR: 3,
    LG2: 4,
    VIRTUAL: 5,
    TOOLKIT: 6
}

export const PRODUCT_CATEGORIES_OBJECT = Object.entries(PRODUCT_CATEGORIES).map(([description, id]) => ({
    description,
    id,
}))

export const PRODUCT_SUBCATEGORIES = {
    COMPOSING_PENDANTS: 1
}

export const PRODUCT_SUBCATEGORIES_OBJECT = Object.entries(PRODUCT_SUBCATEGORIES).map(([description, id]) => ({
    description,
    id,
}))

export const CONFIGURATOR_TYPES = {
    CREA: 1,
    DRAWING: 2,
    NODRAWING: 3,
    EXPRESS: 4,
    COMPOSITOR: 5,
    ATTRIBUTES_CONFIGURATOR: 6,
    MINI_COMPOSITOR: 7,
    PIECES_LIST: 8,
    COMPOSITOR_2D: 9,
    COMPOSITOR_CP_3D: 10
}

export const IS_DOMAIN_CONFIGURATOR_TYPES = [
    CONFIGURATOR_TYPES.ATTRIBUTES_CONFIGURATOR,
    CONFIGURATOR_TYPES.MINI_COMPOSITOR,
    CONFIGURATOR_TYPES.PIECES_LIST,
    CONFIGURATOR_TYPES.COMPOSITOR_2D,
    CONFIGURATOR_TYPES.COMPOSITOR_CP_3D,
]

export const PRODUCT_TYPES = {
    REGULAR: "REGULAR",
    CREATION: "CREATION"
}

export const APPLICATION_LOCATION = {
    COL: 4
}
export const CATALOG = {
    ROW: 16,
    USA: 21
}

export const ARTICLE_TYPE_IDS = {
    luminaryId: 1,
    genericId: 4,
    level2: {
        trackId: 11,
        electricalConnectionId: 8,
        toolboxId: 20
    }
}

export const lightProductTypology = {
    description: {
        en: "Luminaires",
        es: "Luminarias",
        de: "Luminaires",
        fr: "Luminaires",
        it: "Luminaires",
        us: "Luminaires"
    },
    id: 1,
    level1: {
        description: {
            en: "Luminaires",
            es: "Luminarias",
            de: "Luminaires",
            fr: "Luminaires",
            it: "Luminaires",
            us: "Luminaires"
        },
        id: 1
    }
}


export const accessoryProductTypology = {
    description: {
        en: "Accessories",
        es: "Accessories",
        de: "Accessories",
        fr: "Accessories",
        it: "Accessories",
        us: "Accessories"
    },
    id: 2,
    level1: {
        description: {
            en: "Accessories",
            es: "Accessories",
            de: "Accessories",
            fr: "Accessories",
            it: "Accessories",
            us: "Accessories"
        },
        id: 2
    }
}

export const DOCSWEBV2_PROGRESS_CODES = {
    STARTED: 1,
    INTERMEDIATE: 4,
    READY: 8,
    ERROR: 3,
    MAX: 17
}

export const DOCSWEBV2_SUBFAMILIES = [
    234, // Circus
    244, // Bind
]
export const SUBFAMILIES_ID = {
    PLUSMINUS: 225,
    STICKS: 219
}

// familyId values for the 5 compositions eligible for the DV-6607 3D export (DXF/3DS/OBJ).
// Must stay in sync with the FAMILIES map in common/domain/catalog/Product.ts (match, tube,
// algorithm, wireflow, plusminus) — Sticks shares the same WebGL export mechanism in legacy
// but is intentionally excluded here, it is out of this feature's scope.
export const EXPORT_3D_FAMILY_IDS = {
    MATCH: [4100, 4905],
    TUBE: [5014, 5024],
    ALGORITHM: [4994, 5003],
    WIREFLOW: [4160, 4767],
    PLUSMINUS: [5031, 5044],
}

export const EXPORT_3D_PLUSMINUS_FAMILY_IDS = EXPORT_3D_FAMILY_IDS.PLUSMINUS

export const ALL_EXPORT_3D_FAMILY_IDS = Object.values(EXPORT_3D_FAMILY_IDS).flat()

export const accessoriesSubfamiliesExcludedInDomain = [SUBFAMILIES_ID.PLUSMINUS, SUBFAMILIES_ID.STICKS]

const SUBFAMILIES_CODES = {
    MULTIPLE: 259,
    PLUSMINUS: 225,
    ALLTRACK: 267,
}

export const MULTIFAMILY_SUBFAMILY_IDS = [
    SUBFAMILIES_CODES.MULTIPLE,
    SUBFAMILIES_CODES.PLUSMINUS,
]

export const PRODUCT_APPLICATION_IDS = {
    wall_lamps: 17,
    bathroom_lamps: 18,
    hanging_lamps: 19,
    floor_lamps: 20,
    ceiling_lamps: 21,
    outdoor_lamps: 22,
    table_lamps: 23,
    lighting_toolkit: 24,
    wall_hanging_lamps: 25,
    ceiling_hanging_lamps: 26,
    wall_ceiling_lamps: 27,
    floor_wall_lamps: 28
}

export type SortCriteria = 'luminaryShape' | 'lightingEffect'

export const DEFAULT_SORT_CRITERIA: SortCriteria = 'lightingEffect'

export const SORT_CRITERIA_OPTIONS: Array<{ value: SortCriteria; label: string }> = [
    { value: 'luminaryShape', label: 'Luminary Shape' },
    { value: 'lightingEffect', label: 'Lighting Effect' },
]

/**
 * Toolkit pre-design filter categories (Top view / Front view geometry tags), matched against a
 * preconfig's `categories[]`.
 */
export const PRECONFIG_TOP_CATEGORIES = ['Lineal', 'Manta', 'Circular', 'Caotica']
export const PRECONFIG_FRONT_CATEGORIES = ['Horizontal', 'Diagonal', 'Onda', 'Concava', 'Elipse']

export const RATES = {
    IMPORT_USA: 10
}
export const IMPORT_USA_USER = {
    email: "import_usa@vibia.com",
    id: 11709
}

export const INSTALLATION_REMOTE_MODIFIERS = [30, 31, 32]
export const INSTALLATION_FREE_WIRE_MODIFIERS = [18]

export const SUPPORT_TYPE = {
    DEFAULT: 'default',
    CREATION_PRODUCT_INFO: 'creation_product_info',
    PRODUCT_INFO: 'product_info',
    PROJECT_BUDGET: 'project_budget',
    PROJECT_REGISTRATION: 'project_registration',
    BASIC: 'basic',
    EMPTY: 'empty',
    PRODUCT_ISSUES: 'product_issues',
    PRODUCT_ISSUES_BASIC: 'product_issues_basic',
    SERIAL_NUMBER: 'serial_number',
} as const

export default {
    hexDictionary,
    composingPendantSubFamilyCodes,
    DOCSWEBV2_SUBFAMILIES,
    DOCSWEBV2_PROGRESS_CODES,
    SUBFAMILIES_CODES,
    SUBFAMILIES_ID,
    EXPORT_3D_FAMILY_IDS,
    ALL_EXPORT_3D_FAMILY_IDS,
    accessoriesSubfamiliesExcludedInDomain,
    INSTALLATION_REMOTE_MODIFIERS,
    INSTALLATION_FREE_WIRE_MODIFIERS,
    APPLICATION_LOCATION,
    CATALOG,
    MULTIFAMILY_SUBFAMILY_IDS,
}